export const SELECT_IMAGE_MENU_TABS = {
  STOCK_IMAGE: "STOCK_IMAGE",
  UPLOAD_IMAGE: "UPLOAD_IMAGE",
}

export const SELECT_IMAGE_TABS_TEXT = {
  STOCK_IMAGE: "Stock Image",
  UPLOAD_IMAGE: "Upload Image",
}
